(() => {
  if (window.ecodecsCartRecoveryV1) return;
  window.ecodecsCartRecoveryV1 = true;
  let timer;
  let running = false;
  let pending = false;
  let previous = null;
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return !!privacy && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed();
  };
  async function sync() {
    if (running) { pending = true; return; }
    const api = window.klaviyo;
    if (!allowed() || !api?.isIdentified || !api?.identify) return;
    running = true;
    try {
      if (!(await api.isIdentified())) return;
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (!Array.isArray(cart.items) || !allowed()) return;
      const quantities = new Map();
      let supported = true;
      for (const item of cart.items) {
        const id = String(item.variant_id);
        const quantity = Number(item.quantity);
        if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return;
        if (item.selling_plan_allocation || Object.keys(item.properties || {}).length) supported = false;
        quantities.set(id, (quantities.get(id) || 0) + quantity);
      }
      const entries = [...quantities.entries()];
      const path = supported && entries.length
        ? root + 'cart/' + entries.map(([id, quantity]) => id + ':' + quantity).join(',') + '?storefront=true'
        : root + 'cart';
      const signature = JSON.stringify([path, entries]);
      if (signature === previous) return;
      await api.identify({
        ecodecs_cart_recovery_path: path,
        ecodecs_cart_variant_ids: entries.map(([id]) => id),
        ecodecs_cart_item_count: entries.reduce((sum, [,quantity]) => sum + quantity, 0),
        ecodecs_cart_recovery_complete: supported,
        ecodecs_cart_captured_at: new Date().toISOString()
      });
      previous = signature;
    } catch (_) {
    } finally {
      running = false;
      if (pending) { pending = false; schedule(); }
    }
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 300);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  document.addEventListener('visitorConsentCollected', schedule);
  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail?.type === 'submit') {
      previous = null;
      schedule();
      setTimeout(schedule, 2000);
    }
  });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
  schedule();
  [2000, 5000, 10000].forEach(delay => setTimeout(schedule, delay));
})();